<template>
    <div class="supervisor">
        <div v-if="is_loading">
            <div class="ui segment">
                <div class="ui active inverted dimmer">
                    <div class="ui text loader">Loading</div>
                </div>
                <p></p>
            </div>
        </div>
        <div v-else>
            <div class="ui basic buttons">
                <div class="ui basic button" @click="time_interval = 'today'" :class="{active: time_interval == 'today'}">今天</div>
                <div class="ui basic button" @click="time_interval = '1d'" :class="{active: time_interval == '1d'}">1d</div>
                <div class="ui basic button" @click="time_interval = '7d'" :class="{active: time_interval == '7d'}">7d</div>
                <div class="ui basic button" @click="time_interval = '1m'" :class="{active: time_interval == '1m'}">1m</div>
                <div class="ui basic button" @click="time_interval = '3m'" :class="{active: time_interval == '3m'}">3m</div>
                <div class="ui basic button" @click="time_interval = '6m'" :class="{active: time_interval == '6m'}">6m</div>
                <div class="ui basic button" @click="time_interval = '1y'" :class="{active: time_interval == '1y'}">1y</div>
                <div class="ui basic button" @click="time_interval = 'all'" :class="{active: time_interval == 'all'}">全部</div>
            </div>
            <div class="ui segment">
                <button class="ui basic button" @click="init">更新</button>
                <div class="ui segment" v-if="scan_action_scoped_core_waybills_count">
                    <h1 class="ui header">掃描動作</h1>
                    <table class="ui definition celled table">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="(content, scan_action) in scan_action_scoped_core_waybills_count">{{ scan_action }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="material in materials">
                                <td>{{ material.name }}</td>
                                <td v-for="(content, scan_action) in scan_action_scoped_core_waybills_count">{{ content[material.name] || 0 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="ui segment" v-if="status_prototypes_scoped_core_waybills_count">
                    <h1 class="ui header">貨況</h1>
                    <table class="ui definition celled table">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="(content, status_prototype) in status_prototypes_scoped_core_waybills_count">{{ status_prototype }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="material in materials">
                                <td>{{ material.name }}</td>
                                <td v-for="(content, status_prototype) in status_prototypes_scoped_core_waybills_count">{{ content[material.name] || 0 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="ui segment" v-if="current_condition_scoped_core_waybills_count">
                    <h1 class="ui header">狀態</h1>
                    <table class="ui definition celled table">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="(content, condition) in current_condition_scoped_core_waybills_count" v-if="conditions[condition]">{{ conditions[condition] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="material in materials">
                                <td>{{ material.name }}</td>
                                <td v-for="(content, condition) in current_condition_scoped_core_waybills_count" v-if="conditions[condition]">{{ content[material.name] || 0 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Supervisor",
    props: {
        // assigned_core_waybills: {
        //     type: Array,
        //     default() {
        //         return []
        //     }
        // },
        channel_name: {
            type: String,
            default() {
                return "supervisor";
            }
        },
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            time_interval: "today",
            materials: [],
            scan_action_scoped_core_waybills_count: null,
            status_prototypes_scoped_core_waybills_count: null,
            current_condition_scoped_core_waybills_count: null,
        }
    },
    computed: {
        search_params() {
            return {
                time_interval: this.time_interval,
            }
        },
        conditions() {
            return {
                "trueSHIPPING": "配送中",
                "trueEXCEPTIONING": "異常件",
                "trueTRANSFERING": "轉運中",
                "trueCHECKING": "在站內",
                "trueINTERMODALING": "聯運中",
                "trueLOCKING": "鎖定中",
                "falseIS_DONE": "未完成",
                "trueIS_DONE": "已完成",
                "上傳": "上傳",
            }
        }
    },
    mounted() {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_loading = true
                resolve()
            })
            await this.fetch_materials()
            await this.fetch_supervisor()
            await new Promise(resolve => {
                setTimeout(() => {
                    this.is_loading = false
                }, 300)
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })

            // communication channel
            this.$bus.$off(this.channel_name)
            this.$bus.$on(this.channel_name, (command, params) => {
                switch (command) {
                    case "init":
                        this.init()
                        break
                    case "change_time_interval":
                        this.time_interval = params
                        break
                }
            })
        },
        fetch_materials() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_materials).parse(
                {},
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.materials = response.data.materials
                    } else {
                        console.log(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error('取得 materials 失敗')
                })
                .then(() => {
                })
        },
        fetch_supervisor() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_supervisor).parse(
                {},
                "?" + object_to_query(this.search_params)
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.scan_action_scoped_core_waybills_count = response.data.scan_action_scoped_core_waybills_count
                        this.status_prototypes_scoped_core_waybills_count = response.data.status_prototypes_scoped_core_waybills_count
                        this.current_condition_scoped_core_waybills_count = response.data.current_condition_scoped_core_waybills_count
                    } else {
                        console.log(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    this.$noty.error('取得supervisor失敗')
                })
                .then(() => {
                })
        },
    },
    components: {
    }
}
</script>

<style scoped>
.ui.segment {
    overflow-x: auto;
}
</style>
